var KEY_PREFIX = 'wb_score_draft_'

export function saveScoreDraft(subMatchId, scores) {
  if (!subMatchId) {
    return
  }
  try {
    window.sessionStorage.setItem(KEY_PREFIX + subMatchId, JSON.stringify({
      homeScore: scores.homeScore,
      awayScore: scores.awayScore
    }))
  } catch (e) {
    // ignore quota errors
  }
}

export function loadScoreDraft(subMatchId) {
  if (!subMatchId) {
    return null
  }
  try {
    var raw = window.sessionStorage.getItem(KEY_PREFIX + subMatchId)
    if (!raw) {
      return null
    }
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function clearScoreDraft(subMatchId) {
  if (!subMatchId) {
    return
  }
  try {
    window.sessionStorage.removeItem(KEY_PREFIX + subMatchId)
  } catch (e) {
    // ignore
  }
}
